export const AUTH_AUTHORITY = 'https://login.microsoftonline.com/viacom.onmicrosoft.com';
export const DEFAULT_SCOPE = '/.default';
//# sourceMappingURL=auth-api.config.js.map